import { render, staticRenderFns } from "./DeskView.vue?vue&type=template&id=8dec2de6"
import script from "./DeskView.vue?vue&type=script&lang=js"
export * from "./DeskView.vue?vue&type=script&lang=js"
import style0 from "./DeskView.vue?vue&type=style&index=0&id=8dec2de6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports